export const getPreviewFiller = (filler, size) => filler.preview_photos?.find(p => p.includes(size)) ?? filler.preview_url ?? '';
// ─── API ──────────────────────────────────────────────────────────────────────
export const fillers = (apiClient) => {
    return {
        async available(params) {
            const query = new URLSearchParams({
                width: String(params.width),
                height: String(params.height),
                slotType: params.slotType,
            });
            const res = apiClient.requestGet(`/fillers/available?${query}`);
            return res;
        },
        calculate(params) {
            const res = apiClient.request('/fillers/calculate', params);
            return res;
        },
        getSys(params) {
            return apiClient.request('/fillers/get_sys', params);
        },
    };
};
